import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export type HitType =
  | 'entidad' | 'encargo' | 'actor' | 'documento'
  | 'interaccion' | 'factura' | 'foto' | 'comentario';

export interface GlobalHit {
  _type: HitType;
  _title: string;
  _subtitle?: string;
  _route: string;
  _score: number;
  icon?: string;
  highlight?: string;
}

@Injectable({ providedIn: 'root' })
export class SearchService {
  private http = inject(HttpClient);

  search(q: string, limit = 10): Observable<GlobalHit[]> {
    const params = new HttpParams()
      .set('q', (q ?? '').trim())
      .set('limit', String(limit));

    return this.http.get<any>(`${environment.apiGesNormUri}/search`, { params }).pipe(
      map(res => Array.isArray(res) ? res : (res?.items ?? [])),
      map((hits: GlobalHit[]) => hits.map(h => ({ ...h, icon: this.iconFor(h._type) })))
    );
  }

  private iconFor(t: HitType) {
    switch (t) {
      case 'entidad': return 'apartment';
      case 'encargo': return 'assignment';
      case 'actor': return 'person';
      case 'documento': return 'description';
      case 'interaccion': return 'forum';
      case 'factura': return 'receipt_long';
      case 'foto': return 'photo';
      case 'comentario': return 'chat';
      default: return 'search';
    }
  }
}
